import api from './api';

const activityLogService = {
  getActivityLog: async () => {
    return api.get('/auth/activity-log');
  },

  reportLogin: async (eventId) => {
    return api.post('/auth/activity-log/report-login', {
      event_id: eventId
    });
  }
};

export default activityLogService;
